import { render, staticRenderFns } from "./form.vue?vue&type=template&id=f6f2f072&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6f2f072')) {
      api.createRecord('f6f2f072', component.options)
    } else {
      api.reload('f6f2f072', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=f6f2f072&", function () {
      api.rerender('f6f2f072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/payment-schedule/form.vue"
export default component.exports